import React from "react";
import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import styles from "./Loginpage.module.css";
import LoginButton from "../../components/LoginButton";
import SignUpButton from "../../components/SignUpButton";
import {
    Box,
    Container,
    IconButton,
    InputAdornment,
    TextField,
    ThemeProvider,
    createTheme,
    Button,
} from "@mui/material";
import { Context, useContext } from "../../Context";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { URL, origin } from "../../config";
import ForgotPassword from "../../components/ForgotPassword";
import { Helmet } from "react-helmet-async";

export default function LoginPage(props) {
    const [name, setName] = useState("");
    const [pass, setPass] = useState("");
    const [isError, setError] = useState("");
    const navigate = useNavigate();
    const { setUserName } = useContext(Context);
    const [showPass, setShowPass] = useState(false);
    const [openPasswordReset, setOpenPasswordRest] = useState(false);

    const theme = createTheme({
        palette: {
            secondary: {
                main: "#EEEEEE",
            },
        },
    });

    const handleSubmit = (e) => {
        e.preventDefault();

        const data = {
            username: name,
            password: pass,
        };

        fetch(`${URL}/login/`, {
            method: "POST",
            mode: "cors",
            credentials: "include",
            headers: {
                "content-type": "application/json",
                Origin: `${origin}`,
            },
            body: JSON.stringify(data),
        })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                if (data.error) {
                    setError(data.error.message);
                    throw new Error(data.error.message);
                }
                localStorage.setItem("name", name);
                setUserName(name);
                setError("");
                navigate("/dashboard");
            })
            .catch((err) => {
                console.error(err);
            });
    };

    const handleShowPass = () => {
        setShowPass((show) => !show);
    };

    const closePasswordResetModal = () => {
        setOpenPasswordRest(false);
    };

    const openPasswordResetModal = () => {
        setOpenPasswordRest(true);
    };
    return (
        <>
            <Helmet>
                <title>WealthWatch | Log in</title>
            </Helmet>
            <ThemeProvider theme={theme}>
                <h1 className={styles.title}>Login.</h1>
                <Container
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "50%",
                        "@media (max-width: 75em)": {
                            width: "80%",
                        },
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            py: "0px",
                            px: "0px",
                            m: 0,
                        }}
                    >
                        <form>
                            <TextField
                                error={isError ? true : false}
                                size="small"
                                sx={{ my: 1, p: 0, width: "100%" }}
                                type="text"
                                label="username"
                                name="username"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                            <TextField
                                sx={{ width: "100%" }}
                                error={isError ? true : false}
                                helperText={isError}
                                size="small"
                                type={showPass ? "text" : "password"}
                                label="password"
                                name="password"
                                variant="outlined"
                                value={pass}
                                onChange={(e) => setPass(e.target.value)}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={handleShowPass}
                                                edge="end"
                                            >
                                                {showPass ? (
                                                    <VisibilityOff />
                                                ) : (
                                                    <Visibility />
                                                )}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />

                            <LoginButton
                                type="submit"
                                onClick={handleSubmit}
                                sx={{ width: "100%", my: 2 }}
                            >
                                Log in
                            </LoginButton>
                        </form>
                    </Box>
                    <h4 className={styles.or}>or</h4>
                    <SignUpButton
                        className={styles.signupButton}
                        disabled
                        onClick={() => {
                            navigate("/signup");
                        }}
                    >
                        Sign up
                    </SignUpButton>
                    {isError ? (
                        <Button
                            sx={{ my: 2 }}
                            color="error"
                            onClick={openPasswordResetModal}
                        >
                            Forgot Password?
                        </Button>
                    ) : (
                        <></>
                    )}
                    <ForgotPassword
                        open={openPasswordReset}
                        onClose={closePasswordResetModal}
                    />
                </Container>
            </ThemeProvider>
        </>
    );
}
